module.exports = __webpack_public_path__ + "img/zko6.da34e4da.jpg";